export var UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export var SET_ACCOUNT_IS_LOADING = "SET_ACCOUNT_IS_LOADING";
export var RESET_STATE = "RESET_STATE";
export var LOGOUT = "ACCOUNT_LOGOUT";
export var GET_ACCOUNT = "GET_ACCOUNT";
export var GET_CUSTOMER_ACCOUNT = "GET_CUSTOMER_ACCOUNT";
export var UPDATE_CUSTOMER_ACCOUNT = "UPDATE_CUSTOMER_ACCOUNT";
export var SET_CUSTOMER_ACCOUNT_IS_LOADING = "SET_CUSTOMER_ACCOUNT_IS_LOADING";
